import * as React from 'react';
import {Calendar} from '@wix/wix-ui-icons-common/on-stage';
import {OrderItemAction} from '@wix/wixstores-graphql-schema-node';
import {Item} from '../../../../../../../types/app.types';
import {ADD_TO_CALENDAR_ACTION_ID} from '../../../../../constants';
import {LayoutDataHook} from '../../../Layout/Layout';
import {classes} from '../../../ProductLineItemsSection/ProductLineItemOverride.st.css';
import {ProductLineItemBase} from '../../ProductLineItemBase';

export interface ActionsProps {
  item: Item;
  onLineItemActionClick: (action: OrderItemAction) => void;
}

export const Actions = ({item, onLineItemActionClick}: ActionsProps) => {
  if (!item.actions?.length) {
    return null;
  }

  return (
    <>
      {item.actions.map((action: OrderItemAction) => (
        <ProductLineItemBase.Link
          key={action.actionId}
          title={action.label ?? /* istanbul ignore next */ ''}
          icon={
            action.actionId === ADD_TO_CALENDAR_ACTION_ID ? (
              <Calendar data-hook={LayoutDataHook.calendarIcon} className={classes.linkIcon} />
            ) : null
          }
          href={action.url ?? /* istanbul ignore next */ ''}
          onClick={() => onLineItemActionClick(action)}
          className={classes.myLink}
        />
      ))}
    </>
  );
};

Actions.displayName = 'ProductLineItem.Actions';
